import React from "react";
import RVSVisualMock from "./RVSVisualMock";
import Gallery from "./components/Gallery";
import ContactForm from "./components/ContactForm";

function App(): React.JSX.Element {
  return (
    <div>
      {/* Pehle ka RVS Visual Mock */}
      <RVSVisualMock />
    </div>
  );
}

export default App;
